import React from 'react'

import { Grid } from '@material-ui/core/'
import PropTypes from 'prop-types'

import BannerHeader from 'components/BannerHeader'

const MetricSection = ({ title, subtitle, tooltip, children, metric, metricPrevMonth }) => {
  const metricChange = metric - metricPrevMonth

  const data = metric || metric === 0 ? metric.toLocaleString() : undefined

  const secondaryData = () => {
    if (!metricPrevMonth) return ''

    return metricChange >= 0
      ? `+${metricChange.toLocaleString()} in the last 30 days`
      : `${metricChange.toLocaleString()} in the last 30 days`
  }

  return (
    <React.Fragment>
      <Grid
        item
        xs={12}
      >
        <BannerHeader
          title={title}
          subtitle={subtitle}
          tooltip={tooltip}
          data={data}
          secondaryData={secondaryData()}
        />
      </Grid>
      {children}
    </React.Fragment>
  )
}

MetricSection.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  tooltip: PropTypes.string,
  metric: PropTypes.number,
  metricPrevMonth: PropTypes.number,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
}

export default MetricSection
